import BasicService from "./BasicService";

class EmloyeeService extends BasicService {
  constructor() {
    super();
  }
  /**
   *
   * @param {Number} itemId - itemId, not a collect id
   */
  getAllDeliveryForCollect(itemId) {
    let url = "/useraccounts";
    return this.axios
      .get(url, {
        params: {
          itemId,
          action: "COLLECT",
          type: "DELIVERY" //user type
        }
      })
      .then(response => response.data);
  }

  /**
   *
   * @param {Number} itemId - itemId, not a collect id
   */
  getAllDeliveryForAssign(itemId) {
    let url = "/useraccounts";
    return this.axios
      .get(url, {
        params: {
          itemId,
          action: "ASSIGN",
          type: "DELIVERY" //user type
        }
      })
      .then(response => response.data);
  }
  getUserAccountsByTaskUser() {
    let url = "/useraccounts/taskuser";
    return this.axios
      .get(url)
      .then(response => response.data);
  }
  getAllDelivery() {
    let url = "useraccounts/delivery";
    return this.axios.get(url).then(response => response.data);
  }
}

const employeeService = new EmloyeeService();
export default employeeService;
